import { render, staticRenderFns } from "./TkHotelCardPrice.vue?vue&type=template&id=74b8037e&"
import script from "./TkHotelCardPrice.vue?vue&type=script&lang=js&"
export * from "./TkHotelCardPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports